import type { DefaultArtDto } from '@nsb/core';

/**
 * How far the organization's own banners are, in words (Settings → Art): none until where NSB is is picked. The strips
 * behind the funnel are counted without a whole: they are painted as the funnels' time frames ask for them. While they
 * are being painted the row's painting tag says so, so the words say only how far they have got.
 */
export function defaultArtWords(art: DefaultArtDto): string | null {
  if (!art.place) return null;
  const strips = art.strips === 1 ? '1 strip' : `${art.strips} strips`;
  const done = `${art.months} of 12 months, and ${strips} of the seasons behind the funnel`;
  if (art.painting) return `${done} so far.`;
  return `${done}${art.failed ? `; ${art.failed} did not paint` : ''}.`;
}
